"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPurchaseEventObject = void 0;
const TSalesOrderType_1 = require("../../types/TSalesOrderType");
const isDeliverySalesOrderItem_1 = require("../isDeliverySalesOrderItem");
const createPurchaseEventObject = (salesOrder, appType) => Object.assign({
    transaction_id: salesOrder.salesOrderId,
    value: salesOrder.totalPrice,
    tax: salesOrder.totalPrice * 0.1,
    shipping: salesOrder.type === TSalesOrderType_1.TSalesOrderType.Delivery
        ? salesOrder.salesOrderItems.find(item => (0, isDeliverySalesOrderItem_1.isDeliverySalesOrderItem)(item, env.deliveryId)).price
        : 0,
    currency: "AUD",
    app_type: appType,
    items: salesOrder.salesOrderItems
        // don't show delivery in the list of products
        .filter((salesOrderItem) => !(0, isDeliverySalesOrderItem_1.isDeliverySalesOrderItem)(salesOrderItem, env.deliveryId))
        .map((salesOrderItem) => ({
        item_id: salesOrderItem.productId,
        item_name: salesOrderItem.title,
        item_category: salesOrderItem.category.label,
        price: salesOrderItem.price,
        quantity: salesOrderItem.quantity
    }))
});
exports.createPurchaseEventObject = createPurchaseEventObject;
//# sourceMappingURL=createPurchaseEventObject.js.map